__turbopack_context__.v({
  "container": "container-module-scss-module__XCjq4q__container",
});
